import { Typography, Tooltip, Stack, colors } from '@ui-components/neo.tax';
import { ReactComponent as WarningTriangle } from '@ui-components/neo.tax/dist/icons/warning-triangle.svg';

interface SredPayrollExpenseNameCellProps {
  name: string;
  hasSredPayrollExpense: boolean;
  isPiiRedacted: boolean;
  onClick: () => void;
}

export const SredPayrollExpenseNameCell = ({
  hasSredPayrollExpense,
  isPiiRedacted,
  name,
  onClick,
}: SredPayrollExpenseNameCellProps): React.ReactElement => {
  const commonProps = {
    fontWeight: 'medium' as const,
    fontSize: 'inherit' as const,
    lineHeight: 'inherit' as const,
    textOverflow: 'truncate' as const,
    title: name ?? undefined,
  };
  if (hasSredPayrollExpense) {
    if (isPiiRedacted) {
      return (
        <Typography color="inherit" {...commonProps}>
          {name}
        </Typography>
      );
    }

    return (
      <Typography as="button" color={colors.primary[600]} onClick={onClick} {...commonProps}>
        {name}
      </Typography>
    );
  }
  return (
    <Stack direction="row" alignItems="center" gap={2} overflow="hidden">
      <Typography color="inherit" {...commonProps}>
        {name}
      </Typography>
      <Tooltip text="Payroll data is missing">
        <WarningTriangle width={16} color={colors.lemon[400]} />
      </Tooltip>
    </Stack>
  );
};
